<template>
        <div>
            <CRow>
                <CCol>
                    <ejs-grid id="gridStates" ref='grid' :dataSource='stateData' :allowFiltering='true' :allowPaging='true' :allowResizing='true' :allowReordering='true' :allowSorting='true' :toolbar='toolbar' :editSettings='editSettings' :pageSettings='pageSettings' :filterSettings='filterOptions' :toolbarClick='toolbarClick' :actionBegin='actionBegin' :actionComplete="actionComplete" :actionFailure="actionFailure" :allowExcelExport='true' :excelExportComplete='excelExportComplete'>
                        <e-columns>
                            <e-column field='stateId' headerText='' :isPrimaryKey='true' :visible='false'></e-column>
                            <e-column field='stateName' headerText='Country' ref='dplState':validationRules="requiredRules" width=120 :dataSource='states' :edit='stateParams'></e-column>
                            <e-column field='currencyId' headerText='Currency' :validationRules="requiredRules" width=120 :edit='currencyParams' foreignKeyField='currencyId' foreignKeyValue='name' :dataSource='currency' editType='dropdownedit'></e-column>
                            <e-column field='alpha2' headerText='Alpha 2 Code' :validationRules="alpha2Rules" width=120></e-column>
                            <e-column field='alpha3' headerText='Alpha 3 Code' :validationRules='alpha3Rules' width=120></e-column>
                        </e-columns>
                    </ejs-grid>
                </CCol>
            </CRow>
        </div>
</template>

<script>
    import Vue from "vue";
    import { mapState, mapActions } from 'vuex'
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import { createElement } from '@syncfusion/ej2-base';
    import { DataManager, WebApiAdaptor, ODataV4Adaptor } from "@syncfusion/ej2-data";
    import { DropDownList, DropDownListPlugin } from "@syncfusion/ej2-dropdowns";
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import gridOptions from '../../../common/gridOptions';
    import axios from 'axios';
    import store from '../../../store';

    import { worldMap } from '../../../common/worldMap.js';
    import SyncHelper from '../../../common/syncfusion'

    Vue.use(DialogUtility);
    Vue.use(GridPlugin);

    let dpCurrency, elCurrency, dpState, elState
    export default {
        name: 'State',
        data() {
            return {
                store: store,
                stateData: SyncHelper.getDataManager("state"),
                pageSettings: gridOptions.pageSettings,
                worldmap: worldMap,
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowAdding: store.state.permissions["Permissions.State.Create"],
                    allowDeleting: store.state.permissions["Permissions.State.Delete"],
                    allowEditing: store.state.permissions["Permissions.State.Update"],
                    mode: 'Dialog'
                },
                requiredRules: { required: true },
                toolbar: ['Add', 'Delete', 'Edit', 'ExcelExport'],

                currency: SyncHelper.getDataManager("utils/currencies"),
                currencyParams: {
                    create: () => {
                        elCurrency = document.createElement('input');
                        return elCurrency;
                    },
                    read: () => {
                        return dpCurrency.value;
                    },
                    destroy: () => {
                        dpCurrency.destroy();
                    },
                    write: (args) => {
                        dpCurrency = new DropDownList({
                            dataSource: this.currency,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Currency',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            cssClass: 'required-input'
                        });
                        dpCurrency.appendTo(elCurrency);
                    }
                },
                stateParams: {
                    create: () => {
                        elState = document.createElement('input');
                        return elState;
                    },
                    read: () => {
                        return dpState.value;
                    },
                    destroy: () => {
                        dpState.destroy();
                    },
                    write: (args) => {
                        dpState = new DropDownList({
                            dataSource: this.states,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: args.rowData.stateName,
                            placeholder: 'Country Name',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            cssClass: 'required-input'
                        });
                        dpState.appendTo(elState);
                        if (args.requestType == 'beginEdit') {
                            dpState.enabled = false;
                        }
                    }
                },
                filterOptions: gridOptions.filterSettings,
                alpha3Rules: {
                    maxLength: 3,
                    minLength: 3,
                    regex: [(args) => { return (/^[A-Z]+$/).test(args['value']) == true; }, 'Only capital letters allowed']
                },
                alpha2Rules: {
                    maxLength: 2,
                    minLength: 2,
                    required: true,
                    regex: [(args) => { return (/^[A-Z]+$/).test(args['value']) == true; }, 'Only capital letters allowed']
                }
            }
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
        },
        methods: {

            toolbarClick(args) {
                gridOptions.excelExport(args, "Country.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
            },
            actionBegin(args) {
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {

                    }
                }
            },
            actionBegin(args) {
                gridOptions.actionBegin(args);

                if (args.requestType == 'save') {

                    showSpinner(document.getElementById('mainSpinner'));

                }

                if (args.requestType == 'refresh') {

                    hideSpinner(document.getElementById('mainSpinner'));

                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);

                if (args.requestType == 'refresh') {

                    hideSpinner(document.getElementById('mainSpinner'));
                    
                }
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
                 hideSpinner(document.getElementById('mainSpinner'));
            },
        },
        computed: {
            states: function () {
                return this.worldmap.features.map(a => a.properties.name)
            }
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    }
</script>

<style>
    #alpha3_Error {
        padding-left: 20px !important;
    }
</style>